// extracted by mini-css-extract-plugin
module.exports = {"H1":"Heading__H1_36DHE","H3":"Heading__H3_Ft54O","H2":"Heading__H2_19sH3","H4":"Heading__H4_2JUAM","H5":"Heading__H5_3m4Tb","OnDark":"Heading__OnDark_2tKug"};